// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13264(9e9e9c89e7)-C08/10/2026-15:32:34-B08/10/2026-15:38:44' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13264(9e9e9c89e7)-C08/10/2026-15:32:34-B08/10/2026-15:38:44",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13264",
  shortHash: "9e9e9c89e7",
  longHash: "9e9e9c89e7b2af0c2d65b892a21ea3d38ad52803",
  dateCommit: "08/10/2026-15:32:34",
  dateBuild: "08/10/2026-15:38:44",
  buildType: "Ansible",
  } ;
